<template>
  <!-- *RPD MHOR  Appv 0.91
  * Copyright (c) 2025, Blue Cover Six LLC . ?John Molt All rights reserved.
  Code licensed under contract To Reno Police Department / City of Reno, in perpetuity -->
  <div>
    <div id="all_cards" style="max-width: none; width: 100%">
      <v-container fluid>
        <v-card
          v-for="reg in lst_regs"
          :key="reg.registrationId"
          style="max-width: none; width: 100%"
          dark
          class="ma-0 pa-0 mt-3 grey darken-3"
          elevation="3"
        >
          <v-card-title>{{ reg.lname }}, {{ reg.fname }}</v-card-title>

          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="4">
                <label>Reference #</label>
                <output>{{ reg.registrationId | prepend100 }}</output>
              </v-col>

              <v-col cols="12" md="4">
                <label>Approved</label>
                <output>{{ reg.approved }}</output>
              </v-col>

              <v-col cols="12" md="4">
                <label>Archived</label>
                <output>{{ reg.archived }}</output>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="4">
                <label>Phone</label>
                <output>{{ reg.phone }}</output>
              </v-col>

              <v-col cols="12" md="4">
                <label>Address</label>
                <output>{{ reg.address }}</output>
              </v-col>

              <v-col cols="12" md="4">
                <label>Email</label>
                <output>{{ reg.email }}</output>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-row dense>


              <v-col cols="12" md="2">
                <v-btn class="btn-size" dark @click="unarchive_prompt(reg)">
                  <v-icon class="mr-1">$loop</v-icon>Unarchive
                </v-btn>
              </v-col>


            </v-row>
          </v-card-actions>
        </v-card>
      </v-container>
    </div>

    <div
      style="height: 2px"
      v-intersect="{
        handler: onIntersect,
        options: { threshold: 0.25, rootMargin: '0px 0px 300px 0px' },
      }"
    ></div>
  </div>
</template>

<script>
import { bus_common } from "../mixins/bus_common";

export default {
  name: "Archived",
  mixins: [bus_common],
  props: ["update_archived"],

  data: function () {
    return {
      lst_regs: [],
      archived_count: 0,
      isLoading: false,
      hasMore: true,
      lastFire: 0,
      minInterval: 500,
    };
  },

  watch: {
    update_archived: function (val) {
      if (val != null) {
        this.reset_and_load();
      }
    },
  },

  filters: {
    prepend100(value) {
      return "100" + String(value);
    },
  },

  methods: {
    prepend100x(num) {
      return "100" + String(num);
    },


unarchive_prompt(reg) {
  var self = this;
console.log("reg.registrationId: " + reg.registrationId);
  const regOut = {
    registrationId: reg.registrationId,
    fname: reg.fname,
    lname: reg.lname,
  };

  this.swall_diag(
    "Unarchive?",
    "You are restoring archived mental health registration for '" +
      regOut.fname +
      " " +
      regOut.lname +
      "'. Do you wish to continue?",
    "question",
    function () {
      self.$emit("unarchive", regOut);
    },
    null,
    null,
    function () {}
  );
},



    onIntersect(entries) {
      const [entry] = entries;
      if (!entry || !entry.isIntersecting) return;
      if (!this.hasMore || this.isLoading) return;

      const now = Date.now();
      if (now - this.lastFire < this.minInterval) return;
      this.lastFire = now;

      this.isLoading = true;
      this.loadMore()
        .catch((err) => console.error("loadMore archived failed:", err))
        .finally(() => {
          this.isLoading = false;
        });
    },

    normalizeRecord(reg) {
      if (reg.triggers && typeof reg.triggers === "string") {
        reg.triggers = reg.triggers.split(",");
      } else if (!Array.isArray(reg.triggers)) {
        reg.triggers = [];
      }

      return reg;
    },

    reset_and_load() {
      this.lst_regs = [];
      this.archived_count = 0;
      this.hasMore = true;
      this.get_archived();
    },

    async loadMore() {
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.count = this.archived_count;
      formIn.page = 3;
      formIn.apiname = "get_archived";

      var self = this;

      return this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);

          if (!data || data.length === 0) {
            self.hasMore = false;
            return;
          }

          for (let index = 0; index < data.length; index++) {
            const reg = self.normalizeRecord(data[index]);
            self.lst_regs.push(reg);
          }

          self.archived_count = self.lst_regs.length;
          console.log("archived count: " + self.archived_count);
        })
        .catch((msg) => {
          self.show_loader(false);
          self.swall_it("Error search", msg.msg, "error", null, null);
          throw msg;
        });
    },

    get_archived() {
      this.isLoading = true;
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.count = 0;
      formIn.page = 3;
      formIn.apiname = "get_archived";

      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_regs = self.mno(data || []);
          self.lst_regs = self.lst_regs.map((reg) => self.normalizeRecord(reg));
          self.archived_count = self.lst_regs.length;
          self.hasMore = (data || []).length === formIn.page;

          console.log("archived data count: " + self.archived_count);
        })
        .catch((msg) => {
          self.swall_it("Error search", msg.msg, "error", null, null);
        })
        .finally(() => {
          self.show_loader(false);
          self.isLoading = false;
        });
    },

    init: function () {
      this.get_archived();
    },

  },

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/site.scss";

.v-expansion-panel-content__wrap {
  background-color: red;
  padding: 0 !important;
}

label {
  font-weight: 800;
}

output {
  margin-left: 5px;
  font-size: 16px;
}

/* Base: 0px and up */
@media (min-width: 0px) {
  .btn-size {
    width: 100%;
  }
}

/* Breakpoint: 768px and up */
@media (min-width: 768px) {
  .btn-size {
    width: auto;
  }
}
</style>